import dynamic from "next/dynamic";
const Header = dynamic(() => import("./common/header"));
const Footer = dynamic(() => import("./common/troofooter"));
import CookieConsent from "../components/common/CookieConsent/CookieConsent";
import { Provider } from "react-redux";
import store from "../store/store";

const 	Layout = ({ children, isNew = false, slug }) => {
	return (
		<Provider store={store}>
			<div id="root">
				<Header isNew={isNew} pageSlug={slug}/>
				<main className="middle-section middle-pad">{children}</main>
				<Footer />
				<CookieConsent />
			</div>
		</Provider>
	);
};
export default Layout;
